"use client";

import { ArrowUp, Users } from "lucide-react";
import { cn } from "@/lib/utils";

interface OutcomeMetric {
  value: string;
  description: string;
}

interface OutcomeMetricCardsProps {
  items: OutcomeMetric[];
  subtitle?: string;
  className?: string;
}

function OutcomeMetricIcon() {
  return (
    <div className="relative h-14 w-14 shrink-0 text-[#b0b7bf]">
      <Users className="h-14 w-14 stroke-[1.8]" />
      <span className="absolute -bottom-1 -right-1 flex h-7 w-7 items-center justify-center rounded-sm bg-white">
        <ArrowUp className="h-7 w-7 text-[#e1a544] stroke-[2.6]" />
      </span>
    </div>
  );
}

export function OutcomeMetricCards({ items, subtitle, className }: OutcomeMetricCardsProps) {
  if (!items.length) {
    return null;
  }

  return (
    <section className={cn("space-y-5", className)} aria-label="Pilot outcome metrics">
      {subtitle ? (
        <p className="text-center text-xl leading-tight text-gray-900 sm:text-2xl">{subtitle}</p>
      ) : null}
      <div className="grid gap-4 md:grid-cols-2">
        {items.map((item) => (
          <article
            key={`${item.value}-${item.description}`}
            className="h-full rounded-3xl border-2 border-dashed border-[#e9a84c] bg-white px-5 py-2.5 sm:px-7 sm:py-3"
          >
            <div className="flex items-start gap-4 sm:gap-5">
              <OutcomeMetricIcon />
              <div className="min-w-0">
                <p className="text-4xl font-semibold leading-none text-[#102f69]">{item.value}</p>
                <p className="mt-2 text-2xl leading-tight text-gray-900 sm:text-[2rem]">{item.description}</p>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
